<template>
  <router-link
    :to="{
      name: 'single-project',
      params: { id: project._id },
    }"
  >
    <v-card class="mx-auto">
      <v-img
        class="white--text align-end"
        height="200px"
        :src="project.file.split(',')[0]"
        lazy-src="https://picsum.photos/id/11/100/60"
      >
        <v-card-title>{{ project.name }}</v-card-title>
      </v-img>
      <v-card-text class="">
        <div>Description: {{ project.description }}</div>
        <div>Project Type: {{ project.type }}</div>
      </v-card-text>
      <vue-element-loading
        v-if="loading"
        :active="loading"
        :is-full-screen="true"
      />

      <v-row justify="center">
        <v-dialog v-model="dialog" scrollable max-width="400px">
          <v-card>
            <v-card-title>Edit Project Details</v-card-title>
            <v-divider></v-divider>
            <div class="tw-flex tw-flex-wrap tw-px-4 tw-mb-6 tw-mt-8">
              <div class="tw-w-full tw-mb-6 md:tw-mb-0">
                <label
                  class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                  for="tonnage"
                >
                  Enter Tonnage Value (Monthly Value)
                </label>
                <input
                  class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none "
                  id="tonnage"
                  type="text"
                  placeholder="e.g Solving Lagos Traffic"
                  v-model="data.tonnage"
                />
              </div>
              <p v-if="errors.tonnage" class="tw-text-xs tw-text-red-500">
                Please enter tonnage
              </p>
            </div>
            <div class="tw-flex tw-flex-wrap tw-px-4 tw-mb-6 ">
              <div class="tw-w-full tw-mb-6 md:tw-mb-0">
                <label
                  class="tw-block tw-uppercase tw-tracking-wide tw-text-gray-700 tw-text-xs tw-font-bold tw-mb-2"
                  for="description"
                >
                  Edit Project Description
                </label>
                <input
                  class="tw-appearance-none tw-block tw-w-full tw-bg-gray-200 tw-text-gray-700 tw-rounded tw-py-3 tw-px-4 tw-mb-3 tw-leading-tight focus:tw-outline-none "
                  id="description"
                  type="text"
                  placeholder="e.g Solving Lagos Traffic"
                  v-model="data.description"
                />
              </div>
              <p v-if="errors.description" class="tw-text-xs tw-text-red-500">
                Please enter decription
              </p>
            </div>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="dialog = false"
                >Close</v-btn
              >
              <v-btn color="blue darken-1" text @click="submit">Update</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-card>
  </router-link>
</template>

<script>
import axios from "axios";
export default {
  props: ["project"],
  data() {
    return {
      loading: false,
      dialog: false,
      errors: {},
      token: "",
      data: {
        description: this.project.description,
      },
    };
  },
  mounted(){
    this.token = localStorage.getItem("eko-carbon-token");
  },
  methods: {
    submit() {
      this.errors = {};
      this.loading = true;
      const self = this;
      let deny = false;
      if (!this.data.description) {
        this.errors.description = true;
        deny = true;
      }
      if (!this.data.tonnage) {
        this.errors.tonnage = true;
        deny = true;
      }

      if (deny) {
        this.loading = false;
        return;
      }

      this.data.project_id = this.project._id;
      axios
        .post(`${this.$baseUrl}/admin/project/update`, this.data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          this.project = response.data.project;
          self.$swal("Success!", "Project Updated Successfully", "success");
          self.loading = false;
          self.dialog = false;
          self.success = true;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          let err_msg = error.response.data ? error.response.data.message : "An error occured"
          self.$swal("Error!", err_msg, "error");
        });
    },
    approveProject() {
      this.loading = true;
      const self = this;
      console.log(this.project);
      axios
        .post(
          `${this.$baseUrl}/admin/project/approve`,
          {
            project_id: this.project._id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          this.project = response.data.project;
          self.$swal("Success!", "Project Approved Successfully", "success");
          self.loading = false;
          self.success = true;
        })
        .catch((error) => {
          self.loading = false;
          self.error = true;
          this.error = error;
          let err_msg = error.response.data ? error.response.data.message : "An error occured"
          self.$swal("Error!", err_msg, "error");
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
